import * as yup from 'yup';

export const EditSchema = yup.object({
	imgMinResolution: yup.number(),
});

export type EditFormType = yup.InferType<typeof EditSchema>;
